import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { CallerService } from '../../../business-services/caller.service';
import { CallerInfoRequestModel, CallHisotryRequestModel } from 'projects/Administration/src/app/business-entities/caller-info-request-model'
import { AppointmentService } from '../../../business-services/appointment.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { ViewCustomerComponent } from '../../customer/view-customer/view-customer.component';
import { CustomerService } from '../../../business-services/customer.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { AddVehicleComponent } from '../../vehicle/add-vehicle/add-vehicle.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CallNoteRequestModel } from '../../../business-entities/call-note-request-model';
import { CallHangupRequestModel, CallTransferRequestModel } from '../../../business-entities/call-request-model';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { MultiCustomerListComponent } from '../../customer/view-customer/customer-details/multi-customer-list/multi-customer-list.component';
import { CustomerDetailsViewModel } from '../../../business-entities/customer-view.model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { EditVehicleComponent } from '../../vehicle/edit-vehicle/edit-vehicle.component';
@Component({
  selector: 'app-caller-info',
  templateUrl: './caller-info.component.html',
  styleUrls: ['./caller-info.component.css'],
})
export class CallerInfoComponent implements OnInit, OnDestroy {
  @Input() callerInfoRequest: CallerInfoRequestModel;

  //#region Declaration
  searchFilterForm: FormGroup;
  callNotesForm: FormGroup;
  callTransferForm: FormGroup;
  isFormSubmitted: boolean = false;
  isThirdPartyActive: boolean = false;
  noteModel: CallNoteRequestModel;
  noteModalRef: NgbModalRef;
  languageCode: string = "";
  userRoleRightsDetails: UserRoleMenu;
  userRoleRightsDetailsVehicle: UserRoleMenu;
  deliverOutsideBusinessHours = false;
  pickupOutsideBusinessHours = false;
  lstFeatures: any[] = [];
  lstCustomer: any[] = [];
  lstVehicle: any[] = [];
  lstCallHistory: any[] = [];
  lstDealer: any[] = [];
  lstBrand: any[] = [];
  lstAppointmentStatus: any[] = [];
  lstAppointment: any[] = [];
  customerName:any;
  mobileNumber:any;
  IsCustomerAddFromVehicle:boolean;
  VehicleNumberOnAddCustomer:string;
  isMultipleCustomer: boolean = false;
  selectedDealer: any;
  selectedCustomer: any;
  selectedVehicleId: any;
  selectedLicensePlateNo: any;

  isPbxEnabled: boolean = false;
  hideAddButtons: boolean = false;
  _clientName: string;
  crmVehicleDetails: any[] = [];
  crmCustomerDetails: any[] = [];
  //#endregion

  //#region Constructor, Init and Destroy
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly cookieservice: CookieService,
    private readonly callerService: CallerService,
    private readonly appointmentService: AppointmentService,
    private readonly customerService: CustomerService,
    private readonly vehicleService: VehicleBusinessService,
    private readonly secureStorage: SecureStorage,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly multiStackPopupService: MultiStackPopupService,
    private readonly userService: UserDataService,
    config: NgbModalConfig
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
  }
  async ngOnInit() {
    this._clientName = localStorage.getItem('Theme');
    this.hideAddButtons = this._clientName === 'mg';
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.userRoleRightsDetailsVehicle = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Vehicle);
    this.searchFilterForm = this.formBuilder.group({
      customerName: [this.callerInfoRequest.customerName],
      languageCode: [this.languageCode],
      licensePlateNo: [this.callerInfoRequest.licensePlateNo],
      mobileNo: [this.callerInfoRequest.mobileNo],
      agentUserId: [this.callerInfoRequest.agentUserId]
    });
    this.callNotesForm = this.formBuilder.group({
      id: [0],
      notes: ['', [Validators.required]]
    });
    this.callTransferForm = this.formBuilder.group({
      destinationNo: ['', [Validators.required]]
    });
    if (this.callerInfoRequest) {
      await this.GetCallerInfo(this.callerInfoRequest);
      await this.GetBrands();
      this.currentLanguageService.featureList.subscribe(
        (res) => {
          this.lstFeatures = res;
          this.isPbxEnabled = this.lstFeatures.find(x => x.featureCode === Enums.FeatureCode.Pbx)?.isActive;
          this.isThirdPartyActive = this.lstFeatures.find(x => x.featureCode === Enums.FeatureCode.ThirdPartyAPI)?.isActive;
        }
      );
    }
  }
  ngOnDestroy(): void {
    this.clearInitObject();
  }
  //#endregion

  //#region Page Methods
  get csf() {
    return this.searchFilterForm.controls;
  }
  get cnf() {
    return this.callNotesForm.controls;
  }
  get ctf() {
    return this.callTransferForm.controls;
  }
  getLocalDate(date) {
    return Utility.ConvertUTCDateToLocalDate(date);
  }
  getTimeDuration(startDate: any, endDate: any) {
    return Utility.GetTimeDuration(startDate, endDate);
  }
  clearInitObject() {
    this.lstCustomer = [];
    this.lstVehicle = [];
    this.lstCallHistory = [];
    this.isMultipleCustomer = false;
    this.selectedDealer = null;
    this.selectedCustomer = null;
  }
  OnSearch(filterType) {
      this.languageCode = this.cookieservice.get('userSelectedLanguage');
      this.callerInfoRequest.customerName= null;
      this.callerInfoRequest.languageCode= this.languageCode;
      this.callerInfoRequest.licensePlateNo= null;
      this.callerInfoRequest.mobileNo= null;
    if (filterType == "LicensePlate") {
      this.lstVehicle = [];
      this.callerInfoRequest.licensePlateNo = this.csf.licensePlateNo.value;
      this.searchFilterForm.controls['mobileNo'].setValue(null);
      this.searchFilterForm.controls['customerName'].setValue(null);
      this.SearchedVehicleDFSearch(this.csf.licensePlateNo.value,false);
    }
    else 
    {
      if (filterType == "Mobile") {
        this.searchFilterForm.controls['licensePlateNo'].setValue(null);
        this.searchFilterForm.controls['customerName'].setValue(null);
        this.callerInfoRequest.mobileNo = this.csf.mobileNo.value;
      }
      else if (filterType == "Name") {
        this.searchFilterForm.controls['licensePlateNo'].setValue(null);
        this.searchFilterForm.controls['mobileNo'].setValue(null);
        this.callerInfoRequest.customerName = this.csf.customerName.value;
      }
      this.VehicleNumberOnAddCustomer = this.csf.licensePlateNo.value;
      this.GetCallerInfo(this.callerInfoRequest);
    }
  }
  OnClose(value) {
    this.activeModal.close({ closeAll: value });
  }
  OnMinimize(value) {
    this.callerService.callerInfo = this.callerInfoRequest;
    this.activeModal.close({ closeAll: value });
  }
  async IsMultipleCustomer() {
    if (this.lstCustomer?.length > 0) {
      const customer = this.lstCustomer.find(x => x.isActive);
      this.selectedCustomer = customer ? customer : this.lstCustomer[0];
      await this.GetCallerVehicle(this.selectedCustomer.customerId, this.selectedCustomer.customerGuid);
    }
    if (this.lstCustomer?.length === 1) {
      this.isMultipleCustomer = false;
    } else {
      this.isMultipleCustomer = true;
    }
  }
  async OnCustomerSelect(customer) {
    this.selectedCustomer = customer;
    await this.GetCallerVehicle(this.selectedCustomer.customerId, this.selectedCustomer.customerGuid);
    if(customer.customerName || customer.customerMobile){
      const searchRequest = {
        birthDate: '',
        customerName: customer.customerName ?? "",
        postCode: null,
        mobile: customer.customerMobile ?? "",
      }
      await this.SearchedCustomerDFSearch(searchRequest, false)
    }
    
  }
  OnAddCustomer(customerId: number = 0, detail: any = undefined) {
    this.spinner.show();
    this.customerService.customerId = customerId;
    this.customerService.customerFromCaller = detail;
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
    modalref.componentInstance.hideCustomer = false;
    modalref.componentInstance.isView = true;
    if(this.IsCustomerAddFromVehicle && this.VehicleNumberOnAddCustomer)
    {
      this.customerService.IsCustomerAddFromVehicle = true;
      this.customerService.VehicleNumber = this.VehicleNumberOnAddCustomer;
    }
    modalref.result.then((response) => {
      if (response.success) {
        this.GetCallerInfo(this.callerInfoRequest);
      }
    });
  }
  OnAddVehicle() {
    if (!this.lstCustomer.length) {
      let errormsg = this.translate.instant("lblCustomerDetailsAreNotFound.");
      this.toaster.warning(errormsg);
    }
    else if (!this.selectedCustomer) {
      let errormsg = this.translate.instant("lblSelectCustomer");
      this.toaster.warning(errormsg);
    }
    else {
      this.spinner.show();
      this.vehicleService.customerId = this.selectedCustomer.customerId;
      this.vehicleService.customerName = this.selectedCustomer.customerName;
      this.vehicleService.customerNo = this.selectedCustomer.customerNo;
      const modalref = this.modalService.open(AddVehicleComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
      modalref.componentInstance.IsSearch = true;
      modalref.result.then(async (response) => {
        if (response) {
          await this.GetCallerVehicle(this.selectedCustomer.customerId, this.selectedCustomer.customerGuid);
          if(this.selectedCustomer.customerName || this.selectedCustomer.customerMobile){
            const searchRequest = {
              birthDate: '',
              customerName: this.selectedCustomer.customerName ?? "",
              postCode: null,
              mobile: this.selectedCustomer.customerMobile ?? "",
            }
            await this.SearchedCustomerDFSearch(searchRequest, false)
          }
        }
      });
    }
  }
  OnAddNote(noteCntent, call) {
    this.callNotesForm.reset();
    this.callNotesForm.patchValue({
      id: call.callHistoryId,
      notes: call.notes,
    });
    this.isFormSubmitted = false;
    this.noteModalRef = this.modalService.open(noteCntent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }
  OnDFSearch() {
    if (this.isThirdPartyActive) {
      let modelBodymsg = this.translate.instant('lblSureToSearchDF');
      let modelHeadermsg = this.translate.instant('lblDFSearch');
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then(() => {
        // This is intentional
      },
        reason => {
          if (reason) {
            this.DFCustomerSearch();
          }
        }
      );
    }
  }
  TransferCallConfirm(transferContent) {
    const modalRef = this.modalService.open(transferContent, { ariaLabelledBy: 'modal-basic-title', size: 'md' })
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        if (reason) {
          this.TransferCall(modalRef);
        }
      });
  }
  private getBrandImage(key: any) {
    if (this.lstBrand?.length > 0) {
      return this.lstBrand.filter(x => x.brandCode.toUpperCase() === key.toUpperCase())[0]?.image;
    }
  }
  async GetBrands() {
    this.lstBrand = this.secureStorage.getKeyData("BrandList");
  }
  onChangeDealer(dealerId: string) {
    this.selectedDealer = this.lstDealer.find(x => x.dealerId == dealerId);
  }
  //#endregion

  //#region API Methods
  async GetCallerInfo(requestModel: CallerInfoRequestModel): Promise<void> {
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.searchFilterForm.patchValue({
      customerName: requestModel.customerName ?? "",
      languageCode: this.languageCode,
      licensePlateNo: requestModel.licensePlateNo ?? "",
      mobileNo: requestModel.mobileNo ?? "",
      agentUserId: requestModel.agentUserId
    });
    if (requestModel.licensePlateNo || requestModel.mobileNo || requestModel.customerName) {
      requestModel.languageCode = this.languageCode;
      this.spinner.show();
      this.clearInitObject();
      await this.callerService.GetCallerInfo(requestModel).then(async (res) => {
        if (res) {
          this.spinner.hide();
          this.lstCustomer = res.customer;
          if (this._clientName === 'mg') {
            this.crmCustomerDetails = this.mapCrmCustomerDetail(res.customer); 
          }
          this.lstDealer = res.dealer;
          this.selectedDealer = this.lstDealer[0];
          await this.IsMultipleCustomer();
          let reqModel: CallHisotryRequestModel = {
            callFromNo: this.csf.mobileNo.value
          }
          await this.GetCallHistory(reqModel);
          if(requestModel.mobileNo || requestModel.customerName){
            const searchRequest = {
              birthDate: '',
              customerName: requestModel.customerName ?? "",
              postCode: null,
              mobile: requestModel.mobileNo ?? "",
            }
            await this.SearchedCustomerDFSearch(searchRequest, true)
          }else if(requestModel.licensePlateNo){
            await this.SearchedVehicleDFSearch(requestModel.licensePlateNo, true)
          }
         
        }else{
          this.spinner.hide();
        }
       
      });
    }
  }
  private mapCrmCustomerDetail(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {
        customer.forEach(element => {
          const single = {
            customerId: element.customerId,
            contactId: element.customerGuid,
            firstName: element.firstName,
            lastName: element.lastName,
            fullName: element.customerName, 
            addressLine1: element.addressLine1,
            city: element.city,
            postCode: element.pinCode,
            email: element.customerEmail,
            phone: element.customerMobile,
            gender: element.customerTypeId,
            state: element.state,
            country: element.country,
            campaignConsent: element.isMarketingConsent,
            emailConsent: element.isEmail,
            smsConsent: element.isSms,
            isMinBilUser: element.isMinBilUser,
            isActive: element.isActive,
            contactRemark: element.remark,
            navisionId: element.navisionId,
            cbid: element.cbid,
            ownerTypeId: element.ownerTypeId
          };
          supperArray.push(single);
        });
      }
    return supperArray;
  }
  private mapCrmVehicleDetails(vehicle: any) {
    let supperArray = [];
    if (vehicle && vehicle.length > 0) {
      vehicle.forEach(element=>{
        let single = Object();
        single.id = element.vehicleId
        single.licensePlateNo = element.licensePlateNo
        single.companyModel = element.companyModel
        single.color = element.color
        single.year = element.year
        single.registrationDate = element.registrationDate
        single.engineSerialNo = element.engineSerialNo
        single.fuelType = element.fuelType
        single.chassisNo = element.chassisNo
        single.companyMakeCode = element.companyMakeCode
        single.vehicleRemarks = element.remark
        single.inspectionPrevDate = element.inspectionLastDate
        single.inspectionNextDate = element.inspectionNextDate
        single.registrationLastDate = element.registrationLastDate
        single.totalWeight = element.totalWeight
        single.curbWeight = element.curbWeight
        single.transmission = element.transmission
        single.numberOfAxles = element.numberOfAxles
        single.axleWeightLimit_Front = element.axleWeightLimit_Front
        single.axleWeightLimit_Rear = element.axleWeightLimit_Rear
        single.noOfCylinders = element.noOfCylinder
        single.cylinderCapacityCM = element.cylinderCapacity
        single.powerKW = element.powerKW
        single.powerHP = element.powerHP
        single.noOfDoors = element.noOfDoors
        single.noOfSeats = element.noOfSeats
        single.ownerTypeId = element.ownerTypeId
        single.contactUniqueId = element.contactVehicleId
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  async GetCallHistory(requestModel: CallHisotryRequestModel): Promise<void> {
    if (requestModel.callFromNo) {
      this.spinner.show();
      await this.callerService.GetCallHistory(requestModel).then((res) => {
        if (res) {
          this.lstCallHistory = res;
        }
        this.spinner.hide();
      });
    }
  }
  async GetCallerVehicle(customerId: number, customerGuid: string): Promise<void> {
    if (customerId || customerGuid) {
      this.spinner.show();
      await this.callerService.GetCallerVehicle(customerId, customerGuid).then((res) => {
        if (res) {
          this.lstVehicle = res;
          this.crmVehicleDetails = this.mapCrmVehicleDetails(res);
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }
  async GetAllAppointmentStatusList() {
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    if (this.lstAppointmentStatus.length === 0) {
      await this.appointmentService.GetAppointmentStatusList(this.languageCode).then(data => {
        if (data?.woStatusList) {
          this.lstAppointmentStatus = data.woStatusList;
          this.appointmentService.appointmentStatusList = this.lstAppointmentStatus;
        }
      });
    }
  }
  async OnNoteSubmit() {
    this.isFormSubmitted = true;
    if (this.callNotesForm.valid) {
      let NoteSaveSuccess = this.translate.instant('lblNoteSaveSuccess');

      let NoteSaveFailed = this.translate.instant('lblNoteSaveFailed');

      this.spinner.show();
      this.noteModel = {
        CallHistoryId: this.cnf.id.value,
        Notes: this.cnf.notes.value
      }
      await this.callerService.saveCallNote(this.noteModel).then((response) => {
        let result = response.responseObject;
        this.spinner.hide();
        if (result) {
          this.toaster.success(NoteSaveSuccess);
          this.noteModalRef.close();
          this.isFormSubmitted = false;
          let requestModel: CallHisotryRequestModel = {
            callFromNo: this.csf.mobileNo.value
          }
          this.GetCallHistory(requestModel);
        } else {
          this.toaster.error(NoteSaveFailed);
        }
      }).catch((_err) => {
        this.spinner.hide();
        this.toaster.error(NoteSaveFailed);
      }).finally(() => {
        this.spinner.hide();
      });
    }
    else {
      return;
    }
  }
  async DFCustomerSearch() {
    this.spinner.show();
    const searchRequest = {
      birthDate: '',
      customerName: this.csf.customerName.value ? this.csf.customerName.value:this.customerName,
      postCode: null,
      mobile: this.csf.mobileNo.value ? this.csf.mobileNo.value : this.mobileNumber
    }
    await this.customerService.getDFCustomerListByAdvanceSearch(searchRequest).then((response) => {
      if (response?.responseObject?.length > 0) {
        const CustomerList = this.customerService.DFCustomerDataMapper(response.responseObject);
        if (CustomerList?.length > 0) {
          this.OpenMultipleCustomerList(CustomerList, CustomerList.length);
        }
      }
      else {
        let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDetailsAreNotFound.");
        this.toaster.error(lblCustomerDetailsAreNotFound);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  OpenMultipleCustomerList(customerList: CustomerDetailsViewModel[], totalCount: number): void {
    const modalref = this.modalService.open(MultiCustomerListComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });

    modalref.componentInstance.customerList = customerList;
    modalref.componentInstance.totalCount = totalCount;
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.OnAddCustomer(0, response.customer);
        }
      }
    );
  }
  OpenAppointmentPopUp(content: any, vehicleId: number, licensePlateNo: string = null) {
    this.spinner.show();
    this.GetAllAppointmentStatusList();
    this.selectedVehicleId = vehicleId;
    this.selectedLicensePlateNo = licensePlateNo;
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentService.getActiveAppointment(vehicleId, this.selectedCustomer.customerId, this.languageCode).then(async (res) => {
      this.spinner.hide();
      if (res?.length > 0) {
        this.lstAppointment = res.map((element, index) => {
          element.rowNumber = index + 1;
          element.brand = element.brandCode ? this.getBrandImage(element.brandCode) : null;
          element.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
          return element;
        });
        this.modalService.open(content, { size: 'lg', windowClass: 'pop-wid1200 pop-hig80vh pop-mh80' });
      }
      else {
        await this.CreateAppointment();
      }
    }).catch((_err) => {
      this.spinner.hide();
    });
  }
  async CreateAppointment() {
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    if ((this.selectedVehicleId > 0 || (this._clientName === 'mg' && this.selectedLicensePlateNo))  && this.selectedCustomer) {
      this.spinner.show();
      let AppointmentDatetime = new Date();
      let viewModel = {
        customerId: this.selectedCustomer.customerId,
        vehicleId: this.selectedVehicleId,
        dealerId: this.selectedDealer.dealerId,
        dealerDmsNo: this.selectedDealer.dealerDmsNo,
        languageCode: this.languageCode,
        bookingDate: AppointmentDatetime,
        packageNumber: '',
        rentalCar: null,
        availCheckInFacility: false,
        deliverCarWithinBusinessHours: this.deliverOutsideBusinessHours,
        pickupCarWithinBusinessHours: this.pickupOutsideBusinessHours,
        isCustomerWaiting: null,
        service: [],
        selectedDate: null,
        isPickUpDropOffService: false,
        PickUpDateTime: AppointmentDatetime,
        Mileage: 0,
        OwnerTypeId: 1,
        IntegrationWithDMS: false,
        AppointmentType: "Order",
        moduleId: Enums.ModuleNames.Appointment,
        GenerateWorkOrderNoPlannerSide: false,
        IFSWorkOrderNumber: "",
        WorkOrderStatusId: Enums.WOStatus.Prepared,
        realtimeDmsSyncAppointment: true,
        IsCreatedByCall: true,
        UserConsent: true,
        IsTnCAccepted: true,
        IsCustomerNotify: true
      }

      let features = this.secureStorage.getKeyData('feature');
      if (this.secureStorage.getKeyData('feature')) {
        if (features?.length > 0) {
          viewModel.GenerateWorkOrderNoPlannerSide = features.find(x => x.featureCode === Enums.FeatureCode.GWoNoPlannerSide)?.isActive;
          viewModel.IntegrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          viewModel.realtimeDmsSyncAppointment = features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
        }
      }
      if (this._clientName === 'mg') {
        const selectedVehicle = this.crmVehicleDetails.find(x => x.licensePlateNo === this.selectedLicensePlateNo);
        const selectedCustomer = this.crmCustomerDetails.find(x => x.contactId === this.selectedCustomer.customerGuid);
        selectedCustomer.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive;
        selectedCustomer.ownerTypeId =  selectedVehicle.ownerTypeId;
        if (selectedCustomer && selectedVehicle && viewModel) {
          const requestBody = {
            vehicle: selectedVehicle,
            customer: selectedCustomer,
            appointment: viewModel
          }
          await this.appointmentService.AddCrmAppointment(requestBody).then(res => {
            if (res.responseCode === Constant.SuccessResponseCode && res.responseObject && !res.responseObject.errorCount) {
              if (res.responseObject.result) {
                //Show dms response failed message
                if (!this.empty(res.responseObject.result.resultMessage)) {
                  this.toaster.error(res.responseObject.result.resultMessage);
                }
                this.appointmentService.isRefreshListing = true;
                let id = this.empty(res.responseObject.result.retValue) ? 0 : parseInt(res.responseObject.result.retValue);
                this.EditAppointment(res.responseObject);
              }
            }
            else{
              let ErrorMsg = this.translate.instant("lblErrorOccured");
              this.toaster.error(ErrorMsg);
            }
            this.spinner.hide();
          }).catch(_err =>{
            let ErrorMsg = this.translate.instant("lblErrorOccured");
            this.toaster.error(ErrorMsg);
            this.spinner.hide();
          });
        }
        
      } else {
        await this.appointmentService.AddAppointment(viewModel).then(res => {
          if (res.responseCode === Constant.SuccessResponseCode) {
            if (res.responseObject.result) {
              //Show dms response failed message
              if (!this.empty(res.responseObject.result.resultMessage)) {
                this.toaster.error(res.responseObject.result.resultMessage);
              }
              let id = this.empty(res.responseObject.result.retValue) ? 0 : parseInt(res.responseObject.result.retValue);
              this.EditAppointment(id);
            }
          }
          else {
            this.spinner.hide();
          }
        }).catch(() => {
          this.spinner.hide();
        });
      }
      
    }
  }
  EditAppointment(id) {
    this.multiStackPopupService.OpenAppointment(id);
  }
  HangupCall(hangupContent) {
    const modalRef = this.modalService.open(hangupContent, { ariaLabelledBy: 'modal-basic-title', size: 'md' })
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        if (reason) {
          let errorMsg = this.translate.instant('lblErrormsgs');
          let failedMsg = this.translate.instant('lblCallHangupFailed');
          let successMsg = this.translate.instant('lblCallHangupSuccess');
          let model: CallHangupRequestModel = {
            CallId: this.callerInfoRequest.callHistory?.CallId,
            CustomerId: 0,
            CallHistoryId: this.callerInfoRequest.callHistory?.CallHistoryId
          }
          this.spinner.show();
          this.callerService.callHangup(model).then((response) => {
            let result = response.responseObject;
            this.spinner.hide();
            if (result && !result?.error) {
              this.toaster.success(successMsg);
              modalRef.close();
            } else {
              this.toaster.error(failedMsg);
            }
          }).catch((_err) => {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }).finally(() => {
            this.spinner.hide();
          });
        }
      });
  }
  TransferCall(modalRef) {
    let errorMsg = this.translate.instant('lblErrormsgs');
    let failedMsg = this.translate.instant('lblCallTransferFailed');
    let successMsg = this.translate.instant('lblCallTransferSuccess');
    if (this.callTransferForm.valid && this.ctf.destinationNo.value) {
      let model: CallTransferRequestModel = {
        CallId: this.callerInfoRequest.callHistory?.CallId,
        CustomerId: 0,
        DestinationNumber: this.ctf.destinationNo.value,
        CallHistoryId: this.callerInfoRequest.callHistory?.CallHistoryId
      }
      this.spinner.show();
      this.callerService.callTransfer(model).then((response) => {
        let result = response.responseObject;
        this.spinner.hide();
        if (result && !result?.error) {
          this.toaster.success(successMsg);
          modalRef.close();
        } else {
          this.toaster.error(failedMsg);
        }
      }).catch((_err) => {
        this.spinner.hide();
        this.toaster.error(errorMsg);
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }
  CheckDealerBrand(content: any, vehicleId: number, makeCode: string, licensePlateNo: string = null) {
    this.spinner.show();
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    const viewModel = { CustomerLatitude: 0, CustomerLongitude: 0, VehicleId: vehicleId, VehicleBrand: makeCode, Language: this.languageCode };
    this.appointmentService.GetAllDealerDetails(viewModel).then((result) => {
      if (result.responseObject && result.responseObject.errorCount === 0 && result.responseCode === Constant.SuccessResponseCode) {
        const lstDealerBrand = result.responseObject.result as any[];
        if (!lstDealerBrand?.length) {
          let errorMsg = this.translate.instant("lblNoDealerAvailabilityForThisVehicleBrand");
          this.toaster.error(errorMsg);
        }
        else if (this.selectedDealer.dealerId) {
          let isValid = lstDealerBrand.find(x => x.dealerId === this.selectedDealer.dealerId);
          if (!isValid) {
            let errorMsg = this.translate.instant("lblNoDealerAvailabilityForThisVehicleBrand");
            this.toaster.error(errorMsg);
          }
          else {
            this.OpenAppointmentPopUp(content, vehicleId, licensePlateNo);
          }
        }
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async SearchedCustomerDFSearch(searchRequest, showCustomer) {
    this.spinner.show();
    await this.customerService.getDFCustomerListByAdvanceSearch(searchRequest).then((response) => {
      if (response?.responseObject?.length > 0) {
        if (showCustomer) {
          const CustomerList = this.customerService.DFCustomerDataMapper(response.responseObject);
          this.bindDataFactoryCustomer(CustomerList);
          let resultList = response.responseObject;
          if (resultList != null) {
            resultList.forEach(v => {
              let vList = v.vehicles;
              if (vList != null) {
                vList.forEach(result => {
                    this.bindDataFactoryVehicle(result);
                });
              }
            });
          }
        } else {
          let resultList = response.responseObject;
          if (resultList != null) {
            resultList.forEach(v => {
              let vList = v.vehicles;
              if (vList != null) {
                vList.forEach(result => {
                    this.bindDataFactoryVehicle(result);
                });
              }else{
                let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
                this.toaster.error(lblCustomerDetailsAreNotFound);
              }
            });
          }else{
            let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
          this.toaster.error(lblCustomerDetailsAreNotFound);
          }
        }
      }
      else {
        if(showCustomer){
          let lblCustomerDetailsAreNotFound = this.translate.instant("lblCustomerDataFactoryNotFound");
          this.toaster.error(lblCustomerDetailsAreNotFound);
        }else{
          let lblCustomerDetailsAreNotFound = this.translate.instant("lblVehicleDataFactoryNotFound");
          this.toaster.error(lblCustomerDetailsAreNotFound);
        }
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  bindDataFactoryVehicle(result){
      let single = Object();
      single.vehicleId = 0
      single.licensePlateNo = result.plateNumber
      single.companyMakeCode = !this.empty(result.brandName) ? result.brandName : "";
      single.companyModel = !this.empty(result.modelName) ? result.modelName : "";
      if(result.color){
        single.color = !this.empty(result.color.text) ? result.color.text : "";
      }else{
        single.color = !this.empty(result.colorText) ? result.colorText : "";
      }
      single.year = !this.empty(result.modelYear) ? result.modelYear : 0;
      if(result.date){
        single.registrationDate = !this.empty(result.date.registration) ? result.date.registration.first : "";
        single.inspectionNextDate = !this.empty(result.date.inspection) ? result.date.inspection.next : "";
      }else{
        single.registrationDate = !this.empty(result.firstRegistrationDate) ? result.firstRegistrationDate : "";
        single.inspectionNextDate = !this.empty(result.nextInspectionDate) ? result.nextInspectionDate : "";
      }
      if(!this.empty(single.registrationDate)){
        single.registrationDate = this.convertdateformat(single.registrationDate);
      }
      if(!this.empty(single.inspectionNextDate)){
        single.inspectionNextDate = this.convertdateformat(single.inspectionNextDate);
      }

      if(result.fuelType){
        single.fuelType = !this.empty(result.fuelType.text) ? result.fuelType.text : "";
      }else{
        single.fuelType = !this.empty(result.fuelTypeText) ? result.fuelTypeText : "";
      }
      single.chassisNo = !this.empty(result.vehicleIdentificationNumber)? result.vehicleIdentificationNumber : "";
      single.ownerName = !this.empty(result.ownerName)? result.ownerName : "";
      single.ownerType = !this.empty(result.ownerType)? result.ownerType : "";
      single.source = 'Data Factory'
      let findIndex = this.lstVehicle.findIndex(x => x.chassisNo === result.vehicleIdentificationNumber);
      if (findIndex < 0) {
        single.isNewVehicle = true;
      }
      single.imported = !this.empty(result.imported) ? result.imported : false;
      this.lstVehicle.push(single);
   
  }
  bindDataFactoryCustomer(CustomerList) {
    if (CustomerList?.length > 0) {
      CustomerList.forEach(element => {
        let single = Object();
        single.customerId = 0;
        single.customerNo = "";
        single.customerGuid = "";
        single.customerName = !this.empty(element.customerName) ? element.customerName : "";
        single.addressLine1 = !this.empty(element.addressLine1) ? element.addressLine1 : "";
        single.addressLine2 = !this.empty(element.addressLine2) ? element.addressLine2 : "";
        single.city = !this.empty(element.city) ? element.city : "";
        single.state = !this.empty(element.state) ? element.state : "";
        single.country = !this.empty(element.country) ? element.country : "";
        single.pinCode = !this.empty(element.pincode) ? element.pincode : "";
        single.customerEmail = !this.empty(element.email) ? element.email : "";
        single.customerMobile = !this.empty(element.mobileNo) ? element.mobileNo : "";
        single.mobileCode = !this.empty(element.mobileCode) ? "+" + element.mobileCode : "";
        single.customerGroup = "";
        single.ownerType = "Owner";
        single.ownerTypeId = "";
        single.customerNo = "";
        single.customerType = element.customerTypeId == 2 ? "Company" : "Individual";
        single.isActive = false
        single.source = 'Data Factory'
        this.lstCustomer.push(single);
      });
    }
  }

  async viewCustomer(customer) {
    this.customerService.customerId = customer.customerId;
    this.customerService.customerNo = customer.customerNo;
    this.customerService.customerName = customer.customerName;
    this.customerService.firstName = customer.firstName;
    this.customerService.lastName = customer.lastName;
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = false;
    modalref.componentInstance.fromVehicleCustomerDetails = false;
    modalref.result.then(
      async (response) => {
        await this.GetCallerInfo(this.callerInfoRequest);
      },
    );
  }

  async EditVehicle(vehicle)
  {
    this.vehicleService.vehicleId = parseInt(vehicle.vehicleId);
    this.vehicleService.licensePlate = vehicle.licensePlateNo;
    this.vehicleService.make = vehicle.companyMakeCode;
    this.vehicleService.model = vehicle.companyModel;
    this.vehicleService.vinNo= vehicle.chassisNo;
    this.vehicleService.vehicleGuid= '';
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.componentInstance.fromWorkOrder = false;
    modalref.result.then(
     async (response) => {
        await this.GetCallerInfo(this.callerInfoRequest);
      },
    );
  }

  convertdateformat(date){
    if(date.includes('-')){
      return date.split('-')[2] + '.' + date.split('-')[1] + '.' + date.split('-')[0]
    }
    else{
      return date.split('.')[0] + '.' + date.split('.')[1] + '.' + date.split('.')[2]
    }
  }

  async SearchedVehicleDFSearch(licensePlateNo,showCustomer){
    this.spinner.show();
    await this.vehicleService.getVehicleFrmoDataFactoryByLicencePlateNo(licensePlateNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if(response.responseObject != null && response.responseObject.length != 0){

          if(response.responseObject[0].vehicles == null || response.responseObject[0].vehicles.length == 0){
            let errorMsg = this.translate.instant('lblVehicleDataFactoryNotFound');
            this.toaster.error(errorMsg);
            this.spinner.hide();
          }
          else{
            let result = response.responseObject[0].vehicles[0];
            this.bindDataFactoryVehicle(result);

            if(showCustomer){
              const CustomerList = this.customerService.DFCustomerDataMapper(response.responseObject);
              this.bindDataFactoryCustomer(CustomerList);
            }
           
            this.spinner.hide();
          }
        }
        else{
          let errorMsg = this.translate.instant('lblVehicleDataFactoryNotFound');
          this.toaster.error(errorMsg);
          this.spinner.hide();
        }
      }
    },
    _error => {
      this.spinner.hide();
    });
  }

  AddCustomerThroughVehicleSearch(event) {
    this.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.spinner.show();
    this.mobileNumber = event.customerMobile;
    this.customerName = event.customerName;
    this.IsCustomerAddFromVehicle = true;
    this.DFCustomerSearch();
    this.currentLanguageService.vehicleAdd.subscribe((x) => {
      if(x == 1)
      {
        let requestModel: CallerInfoRequestModel = {
          customerName: null,
          languageCode: this.languageCode,
          licensePlateNo: this.VehicleNumberOnAddCustomer,
          mobileNo: null,
          agentUserId: this.callerInfoRequest.agentUserId,
        };
        this.GetCallerInfo(requestModel);
        this.currentLanguageService.vehicleAdd.next(0);
      }
    })
    this.mobileNumber = "";
    this.customerName = "";
  }


  async AddNewVehicle(vehicle){
    if(this.selectedCustomer == null){
      let errormsg = this.translate.instant("lblSelectCustomer");
      this.toaster.warning(errormsg);
      return;
    }
    this.vehicleService.vinNo= vehicle.chassisNo;
    this.vehicleService.customerId= this.selectedCustomer.customerId;
    this.vehicleService.customerNo= this.selectedCustomer.customerNo;
    this.vehicleService.customerName= this.selectedCustomer.customerName;
    const modalref = this.modalService.open(AddVehicleComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
    modalref.componentInstance.isAddFromAppointment = false;
    modalref.componentInstance.vehicleDetail = vehicle;
    
    modalref.result.then(async (_response) => {
      if(_response.success){
        await this.GetCallerVehicle(this.selectedCustomer.customerId, this.selectedCustomer.customerGuid);
        if(this.selectedCustomer.customerName || this.selectedCustomer.customerMobile){
          const searchRequest = {
            birthDate: '',
            customerName: this.selectedCustomer.customerName ?? "",
            postCode: null,
            mobile: this.selectedCustomer.customerMobile ?? "",
          }
          await this.SearchedCustomerDFSearch(searchRequest, false)
        }
      }
    });

  }
  //#endregion
}
